<template>
  <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.68457 2.43812L5.35037 7.10392L6.76458 5.6897L6.74668 5.67223L10.1038 2.31534L8.68963 0.901123L5.33268 4.25823L2.09878 1.02391L0.68457 2.43812Z" fill="#292929"/>
  </svg>
</template>